import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import { Toaster } from "./components/ui/sonner";
import "./styles/landing.css";
import { Thankyou } from "./pages/ThankyouPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/thankyou" element={<Thankyou />}/>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
